import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  Form,
  Row,
  Input,
  Button,
  Upload,
  Modal,
  message,
  Tabs,
} from "antd";
import axios from "axios";
import { PlusOutlined } from "@ant-design/icons";
import { getExamEnvFeedbackDetail, submitExamEnvFeedback, uploadFile } from "./api";
import { judgeIsLogin } from "../../common/utils";
import Logo from "../../assets/images/qingcloud_new.svg";
import { getFileUrl, getUploadSign } from "../../Admin/apis/course";

import "./index.less";
import { getKnowledgeListSignUrl } from "../../College/apis/knowledge";

const { TabPane } = Tabs;
const { TextArea } = Input;

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8 },
};

const tailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 24 },
};

const _fileList = [
  {
    uid: '-1',
    name: 'image.png',
    status: 'done',
    url: 'https://pek3b.qingstor.com/test-123test/feedback/1667883397/%E4%BC%81%E4%B8%9A%E5%BE%AE%E4%BF%A120221104-104745.png?access_key_id=DMYRMJPZUGGKLOCWECVR&expires=1667889365&signature=nMUFSvdSgY65Ded9wbcu2NlCw6JJvTq8zVIIiF7Rgv0=',
  },
];


const fileList1 = [
  {
    uid: '-1',
    name: 'xxx.png',
    status: 'done',
    url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
    thumbUrl: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
  },
  {
    uid: '-2',
    name: 'yyy.png',
    status: 'error',
  },
];


function ExamEnvFeedback() {
  const history = useHistory();
  const [readOnly,setReadOnly] = useState(false);
  const [fileList, setFileList] = useState<any>([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [uploadParams, setUploadParams] = useState<any>({});
  const [isShowUpload, setIsShowUpload] = useState(true);
  const [initData,setInitData]=useState<any>({});
  const urlParams: { id: string, type:string } = useParams();
  const userinfo =
    JSON.parse(localStorage.getItem("userinfo") || JSON.stringify({})) || {};


  useEffect(() => {
    if (!userinfo.id) {
      judgeIsLogin();
    }else{
      if(urlParams.type==='view'){
        setReadOnly(true);
        getExamEnvFeedbackDetail({id: urlParams.id}).then((res: any) => {
          if (res && res.code === 0) {
            setInitData(res.data);
            const fileList = res.data.picture.split(',');
            handleDownload(fileList);
            // const newFlieList = fileList.map((item: any)=>{
            //   handleDownload(item);
            // })

          } else {
            res && message.error(res.msg);
          }
        });
      }else{
        setReadOnly(false);
      }
    }
  }, []);


  const handleDownload = (data: any) => {
    let arr:any =[];
    data.map(async (item: any)=>{
      await getKnowledgeListSignUrl({ url: item }).then((res: any) => {
        if (res && res.code === 0) {
          const { url = "" } = res.data;
          const _file= {
            name: "image.png",
            url,
          };
          console.log(fileList)
          arr.push({
            ..._file,
            uid: new Date().getTime(),
            name: "image.png",
        })
          // setFileList([...fileList,{
          //     ..._file,
          //     uid: -(fileList.length+1),
          //     name: "image.png",
          // }])
          // return url;
          // window.open(url);
        } else {
          // res && message.error(res.msg || "操作失败！");
          return null;
        }
      })
      console.log(arr)
      setFileList([...arr])
    })
  
  }
  const goHome = () => {
    history.push("/");
  };

  const goBack = () => {
    history.go(-1);
  };
  
  // 上传图片
  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  // 上传文件之前
  const handleBeforeUpload = (_file: any, _fileList: any) => {
    setFileList([...fileList,_file]);
    return true;
  };

  // 放大图片
  const handlePreview = async (data:any) => {
    if(urlParams.type==='edit'){
      setPreviewVisible(true);
      setPreviewImage(data.thumbUrl);
    }else{
      setPreviewVisible(true);
      setPreviewImage(data.url);
    }
   
  };

  const handleCancel = () => {
    setPreviewVisible(false);
  };

  // 自定义上传
  const handleCustomRequest = (options: any) => {
    let params = {
      file_name: options.file.name,
    };
    getUploadSign(params).then((res: any) => {
      if (res && res.code === 0) {
        const { access_key_id, key, policy, signature, post_url } = res.data;
        let _data: any = {
          access_key_id,
          key,
          policy,
          signature,
          file: options.file,
        };
        let _params = new FormData();
        for (let key in _data) {
          _params.append(key, _data[key]);
        }
        // TODO:
        let url = '/api/v1/exam/feedback/upload';
        if(process.env.NODE_ENV==='development'){
          url = `/e-learning${url}`;
          // url = `/qingcloud/learning/e-learning${url}`;
        }else{
          url = `${window.location.pathname}/e-learning${url}`
        }
        axios({
          method: "post",
          url,
          // url: post_url,
          data: _params,
          headers: {
            "Token": JSON.parse(localStorage.getItem('token') || JSON.stringify(null)) || "",
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            // 对原生进度事件的处理
            const { loaded, total } = progressEvent;
            options.onProgress(
              { percent: Math.round((loaded / total) * 100).toFixed(2) },
              options.file
            );
          },
        }).then((res1:any) => {
          if (res1 && res1?.data?.code == 0) {
            message.success('上传成功！');
            options.onSuccess(res1, options.file);
            setUploadParams({ ...res.data, file_name: options.file.name });

            const newFileList = fileList.map((item: any)=>{
              if(item.uid===options.file.uid){
                item.uploadUrl = res1?.data?.data?.url;
              }
              return item;
            })
            setFileList(newFileList)
          } else {
            message.error("上传失败");
            options.onError(res1, options.file);
          }
        });
      }
    });
  };

  const handleFormValuesChange = (changedFields: any) => {
    changedFields?.fileList?.length > 0
      ? setIsShowUpload(false)
      : setIsShowUpload(true);
  };

  const handleFormFinishFailed = (errors: any) => {
    message.error("请完善信息！");
  };

  const handleFormFinish = (values: any) => {
    const userinfo = JSON.parse(localStorage.getItem('userinfo') || JSON.stringify(null)) || {};
    let params = {
      examID:urlParams.id,
      userID:userinfo.id,
      ...values
    };
    const pictureList = params.fileList.map((item:any)=>{
      return item?.xhr?.uploadUrl;
    }) 
    console.log(pictureList)
    delete params.fileList;

    params.picture = pictureList.join(',')
    if(params.picture){
      // 反馈环境问题提交接口
      submitExamEnvFeedback(params).then((res: any) => {
        if (res && res.code === 0) {
          message.success(res.msg|| '提交成功');
        } else {
          res && message.error(res.msg);
        }
      });
    }else{
      message.error('请完善信息！');
    }
   
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div className="ant-upload-text">上传</div>
    </div>
  );
  return (
    <>
      <div className="exam-before">
        <div className="exam-before-head">
          <div className="head">
            <div className="head-left">
              <div className="logo" onClick={goHome}>
                <img src={Logo} alt="青云" />
                <span className="line">|</span>
                <span className="text">合作伙伴支持平台</span>
              </div>
            </div>
            <div className="head-right">{userinfo.employee_name}</div>
          </div>
        </div>
        <div className="exam-before-content exam-evn-feedback-content">
          <div className="content">
            <div className="detail_basic">
              <Tabs defaultActiveKey="1">
                <TabPane tab="环境异常反馈" key="1">
                  <Row
                    style={{
                      marginTop: 20,
                      marginBottom: 20,
                      height: "100%",
                      overflow: "auto",
                    }}
                  >
                    <Form
                      {...layout}
                      style={{ width: "100%" }}
                      name="basic"
                      onFinish={handleFormFinish}
                      onFinishFailed={handleFormFinishFailed}
                      onValuesChange={handleFormValuesChange}
                    >
                      <Form.Item
                        label="考生姓名"
                        name="userName"
                        rules={[{ required: true, message: "请输入考生姓名" }]}
                      >
                        {
                          readOnly?
                          initData.userName:
                          <Input 
                          disabled={readOnly} 
                          placeholder="请输入考生姓名" />
                        }
                        
                      </Form.Item>
                      <Form.Item
                        label="手机号"
                        name="phone"
                        rules={[{ required: true, message: "请输入手机号" }]}
                      >
                        {
                           readOnly?
                           initData.phone:
                           <Input  disabled={readOnly} placeholder="请输入手机号" />
                        }
                      </Form.Item>
                      <Form.Item
                        label="微信号"
                        name="wechat"
                        rules={[{ required: true, message: "请输入微信号" }]}
                      >
                         {
                           readOnly?
                           initData.wechat:
                           <Input disabled={readOnly} placeholder="请输入微信号" />
                        }
                      </Form.Item>
                      <Form.Item
                        label="邮箱"
                        name="email"
                        rules={[{ required: true, message: "请输入邮箱" }]}
                      >
                        {
                           readOnly?
                           initData.email:
                           <Input disabled={readOnly} placeholder="请输入邮箱" />
                        }
                      </Form.Item>
                      <Form.Item
                        label="异常现象描述"
                        name="describe"
                        rules={[
                          { required: true, message: "请输入异常现象描述" },
                        ]}
                        initialValue={initData?.describe}
                      >
                         {
                           readOnly?
                           initData.describe:
                           <TextArea
                           disabled={readOnly}
                           placeholder="请输入异常现象描述"
                           autoSize={{ minRows: 2, maxRows: 6 }}
                         />
                        }
                       
                      </Form.Item>
                      <Form.Item
                        wrapperCol={{ span: 24 }}
                        label="异常现象截图"
                        name="fileList"
                        valuePropName="fileList"
                        getValueFromEvent={normFile}
                        rules={[
                          { required: true, message: "请上传异常现象截图" },
                        ]}
                        extra={!readOnly && "只能上传jpg/jpeg/png格式图片"}
                      >
                        {
                          !readOnly?
                          <Upload
                          name="file"
                          listType="picture-card"
                          fileList={fileList}
                          showUploadList={{ showDownloadIcon: false }}
                          customRequest={handleCustomRequest}
                          accept=".jpg, .jpeg, .png"
                          beforeUpload={handleBeforeUpload}
                          onPreview={handlePreview}
                          disabled={readOnly}
                        >
                          {/* {isShowUpload ? uploadButton : null} */}
                          { !readOnly &&  uploadButton}
                        </Upload> 
                        :
                        <>
                          <Upload
                            name="file"
                            listType="picture-card"
                            fileList={fileList}
                            showUploadList={{ showDownloadIcon: false }}
                            customRequest={handleCustomRequest}
                            accept=".jpg, .jpeg, .png"
                            beforeUpload={handleBeforeUpload}
                            onPreview={handlePreview}
                            disabled={readOnly}
                          >
                            {/* {isShowUpload ? uploadButton : null} */}
                            { !readOnly &&  uploadButton}
                          </Upload> 
                          <Upload></Upload>
                        </>
                        }
                        
                      </Form.Item>
                    
                    {
                      !readOnly &&
                      <Form.Item {...tailLayout}>
                        <div className="btn-group">
                            
                             <Button type="primary" htmlType="submit">
                             提交
                           </Button>
                          {/* <Button onClick={goBack}>返回</Button> */}
                        </div>
                      </Form.Item>
                    }
                      
                    </Form>
                  </Row>
                  <Modal
                    visible={previewVisible}
                    footer={null}
                    onCancel={handleCancel}
                  >
                    <img
                      alt="example"
                      style={{ width: "100%", height: "100%" }}
                      src={previewImage}
                    />
                  </Modal>
                </TabPane>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExamEnvFeedback;
